<template>
    <div>
        <v-row align="center" justify="end">
            <v-col cols="6">
                <v-card>
                    <v-card-title class="subtitle-1">
                        <v-row no-gutters justify="space-between" align="center">
                            <v-col cols="4">
                                Uploadet mellem
                            </v-col>
                            <v-col cols="2">
                                <div style="width: 70%">
                                    <v-text-field prefix="kl." v-model="hours[0]" class="mt-0 pt-0" hide-details single-line type="number" />
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <v-range-slider v-model="hours" hide-details min="0" max="24" />
                            </v-col>
                            <v-col cols="2" class="d-flex justify-end">
                                <div style="width: 70%">
                                    <v-text-field prefix="kl." v-model="hours[1]" class="mt-0 pt-0" hide-details single-line type="number" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <div v-else-if="noData">
            <v-col>
                Der er ingen emner på kampagner med target service-level tilhørende projektet i den valge periode.
            </v-col>
        </div>
        <div v-else>
            <v-row>
                <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards" :key="index">
                    <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
                </v-col>
            </v-row>
            <v-card>
                <v-tabs v-model="selectedRow">
                    <v-tab @click="switchRows">Kampagner / Tidspunkter</v-tab>
                    <v-tab @click="switchRows">Tidspunkter / Kampagner</v-tab>
                </v-tabs>
                <sales-pivot
                    defaultSort="timely"
                    :dataObject="stats"
                    :fields="fields"
                    :nestedFields="nestedFields"
                    :valueFunctions="valueFunctions" />
            </v-card>
        </div>
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'
import TotalCard from '@/components/totalCard'
import { debounce } from 'debounce'

export default {
    components: {
        SalesPivot,
        TotalCard
    },
    props: {
        tag: String
    },
    data () {
        return {
            loading: true,
            hours: [9, 18],
            selectedRow: 0,
            firstRow: 'Campaign.Name',
            secondRow: 'uploadHour',
            rows: [
                {
                    text: 'Kampagne',
                    value: 'Campaign.Name'
                },
                {
                    text: 'Tidspunkt',
                    value: 'uploadHour'
                }
            ],
            stats: null,
            totalCards: [
                {
                    header: 'Emner over 24 timer til første opkald',
                    formatter: this.$options.filters.separator,
                    value: v => v.dayOld
                },
                {
                    header: 'Overholdt service-level',
                    formatter: this.$options.filters.percentage,
                    value: v => v.uploaded ? 1 - (v.overdue / v.uploaded) : 1
                },
                {
                    header: 'Gns. tid til første opkald',
                    formatter: this.$options.filters.timestamp,
                    value: v => v.uploaded ? v.totalDiff / v.uploaded : 0
                },
                {
                    header: 'Maks. tid til første opkald',
                    formatter: this.$options.filters.timestamp,
                    value: v => v.maxDiff
                }
            ],
            fields: [
                {
                    header: 'Upl.',
                    field: 'uploaded',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Overholdt SL',
                    field: 'timely',
                    cols: '2',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Under 5 min',
                    field: 'fiveminutes',
                    cols: '2',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Under 15 min',
                    field: 'fifteenminutes',
                    cols: '2',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Under 3 timer',
                    field: 'threehours',
                    cols: '2',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Over 24 timer',
                    field: 'oneday',
                    cols: '2',
                    formatter: this.$options.filters.separator
                }
            ],
            valueFunctions: {
                uploaded: v => v.uploaded,
                timely: v => v.uploaded ? 1 - (v.overdue / v.uploaded) : 1,
                fiveminutes: v => v.uploaded ? v.fiveminutes / v.uploaded : 1,
                fifteenminutes: v => v.uploaded ? v.fifteenminutes / v.uploaded : 1,
                oneday: v => v.uploaded - v.oneday,
                threehours: v => v.uploaded ? v.threehours / v.uploaded : 1
            },
            nestedFields: ['uploaded', 'overdue', 'dayOld', 'totalDiff', 'invalid', 'fiveminutes', 'fifteenminutes', 'oneday', 'threehours']
        }
    },
    computed: {
        tab () {
            return this.tabs[this.tabIndex]
        },
        period () {
          return this.$store.state.reports.period  
        },
        range () {
            return this.$store.state.reports.range
        },
        totals() {
            const totals = this.$reduceNested(this.stats, this.nestedFields)
            return {
                ...totals,
                maxDiff: this.maxDiff
            }
        },
        filteredRows () {
            return {
                firstRow: this.rows.filter(row => row.value !== this.secondRow),
                secondRow : this.rows.filter(row => row.value !== this.firstRow),
            }
        },
        report () {
            return this.$store.getters['reports/currentReport']
        },
        groupIndex () {
            return this.$store.state.reports.groupIndex
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().post('/reports/service', {
                from: this.range[0],
                to: this.range[1],
                openingHour: this.hours[0],
                closingHour: this.hours[1],
                firstKey: this.firstRow,
                secondKey: this.secondRow,
                campaigns: this.$store.getters['reports/campaigns']
            })
            if (response.status === 204) {
                this.noData = true
            } else {
                this.noData = false
                this.stats = response.data.stats
                this.maxDiff = response.data.maxDiff
            }
            this.loading = false
        },
        switchRows () {
            const tempFirstRow = this.firstRow
            this.firstRow = this.secondRow
            this.secondRow = tempFirstRow
        }
    },
    watch: {
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
		hours: {
			handler: debounce(function () {
                this.getData();
            }, 1000),
			deep: true
        },
        report: function () {
            this.getData()
        },
        firstRow: function () {
            this.getData()
        },
        secondRow: function () {
            this.getData()
        },
        groupIndex: function () {
            this.getData()
        }
    },
    async created () {
        this.getData()
    }
}
</script>